import { Moment } from "moment";
import { griveanceCategory } from "src/models/manage-artifact-filter.model";

export enum ActionDate {
  last7Days = "last-7-days",
  last15Days = "last-15-days",
  custom = "custom",
}

export enum UserStatus {
  active = "active",
  blocked = "blocked",
  inactive = "inactive",
}

export enum VisibilityStatus {
  open = "Open",
  restricted = "Restricted",
  private = "Private",
  shared = "Shared",
}

export enum ActiveStatus {
  hidden = "Hidden",
  active = "Active",
}

export enum ArtifactType {
  dataset = "dataset",
  model = "model",
  usecase = "usecase",
}

export enum InstanceTypes {
  CPU = 'CPU',
  GPU = 'GPU'
}

export enum UsageCategory {
  Basic = 'basic',
  Advance = 'advance'
}

export const DISPUTED_GRIEVANCES_COLUMN_HEADERS = [
  {
    name: "Tracking ID",
    key: "number",
    type: "text",
    width: "160px",
    event: "tickedId",
    spanStyle: {
      "text-decoration": "underline",
      "text-decoration-style": "solid",
      "text-decoration-offset": "0%",
      "text-decoration-thickness": "0%",
      cursor: "pointer",
    },
  },

  { name: "Type", key: "artefact_type", type: "text", width: "160px" },

  { name: "Artefact Name", key: "artefact_name", type: "text", width: "160px" },
  {
    name: "Reported By",
    key: "reportedBy",
    type: "text",
    width: "196px",
    // iconUrl: "assets/images/info-line.svg",
    avatarKey: "reportedByProfilePic",
  },
  { name: "Subject", key: "subject", type: "text", width: "160px" },
  {
    name: "Artefact Owner",
    key: "currentOwner",
    type: "text",
    width: "196px",
    // iconUrl: "assets/images/info-line.svg",
    avatarKey: "ownerProfilePic",
  },

  { name: "Submission Date", key: "created", type: "text", width: "122px" },
  { name: "Status", key: "status", type: "text", width: "155px" },
];

export const GENERAL_GRIEVANCES_COLUMN_HEADERS = [
  {
    name: "Tracking ID",
    key: "number",
    type: "text",
    width: "160px",
    event: "tickedId",
    spanStyle: {
      "text-decoration": "underline",
      "text-decoration-style": "solid",
      "text-decoration-offset": "0%",
      "text-decoration-thickness": "0%",
      cursor: "pointer",
    },
  },
  { name: "Category", key: "department", type: "text", width: "160px" },
  { name: "Subject", key: "subject", type: "text", width: "160px" },

  {
    name: "Reported By",
    key: "reportedBy",
    type: "text",
    width: "196px",
    // iconUrl: "assets/images/info-line.svg",
    avatarKey: "reportedByProfilePic",
  },

  // { name: "User Role", key: "name", type: "text", width: "160px" },

  { name: "Submission Date", key: "created", type: "text", width: "122px" },
  { name: "Status", key: "status", type: "text", width: "155px" },
];

export interface ArtefactFilterOptions {
  actionDate?: {
    fromDate: Moment | Date | string;  
    toDate: Moment | Date | string;
  };
  dateFilterType?: { label: string; value: ActionDate };
  category?: { label: string; value: griveanceCategory }[];
  artifactType?: { label: string; value: ArtifactType }[];
  searchText?: string;
  selectedCheckboxOptions?: string[];
  userStatusType?: { label: string; value: UserStatus };
  visibility?: { label: string; value: VisibilityStatus };
  isActive?: { label: string; value: ActiveStatus };
  organizationType?: { label: string; value: string }[];
  instanceTypes?: { label: string; value: InstanceTypes };
  usageCategory?: { label: string; value: UsageCategory };
}

export const PROMOTIONAL_EMAIL_HEADERS = [
  { name: "TEMPLATE NAME", key: "name", type: "text", width: "80px", event: "templateName", spanStyle: {
    "text-decoration": "underline",
    "text-decoration-style": "solid",
    "text-decoration-offset": "0%",
    "text-decoration-thickness": "0%",
    cursor: "pointer",
  } },
  { name: "EMAIL SUBJECT", key: "subject", type: "text", width: "100px" },
  { name: "TYPE", key: "type", type: "text", width: "20px" },
  { name: "STATUS", key: "status", type: "text", width: "10px", spanStyle: {
    "text-transform": "capitalize",
    "padding": "8px 16px",
    "border-radius": "12px",
  } },
  { name: "UPDATED DATE", key: "created_at", type: "text", width: "50px" },
];

export const EMAIL_LOGS = [
  
  { name: "Template Name", key: "template_name", type: "text", width: "100px" },
  { name: "Subject", key: "subject", type: "text", width: "100px" },
  { name: "Email Sent To", key: "email_sent_to", type: "text", width: "50px" },
  { name: "No. Of Recipients", key: "no_of_recipients", type: "text", width: "50px" },
  { name: "Last Updated", key: "last_updated", type: "text", width: "80px" },
];